import { render, staticRenderFns } from "./LatestEventBlock.vue?vue&type=template&id=68377e30&scoped=true&"
import script from "./LatestEventBlock.vue?vue&type=script&lang=js&"
export * from "./LatestEventBlock.vue?vue&type=script&lang=js&"
import style0 from "./LatestEventBlock.vue?vue&type=style&index=0&id=68377e30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68377e30",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VacanciesEventsCards: require('/var/www/ct-frontend/ct-front-20261029043307/components/vacancies/events-block/VacanciesEventsCards.vue').default})
